<template>
    <div class="commentComposer">
        <div class="commentComposer__inner">
            <div class="commentComposer__avatar">
                <avatar-image :url="user.avatar" />
            </div>
            <!--/.commentComposer__avatar-->
            <div class="commentComposer__input">
                <editor-content :editor="editor" />
            </div>
            <!--/.commentComposer__input-->
        </div>
        <!--/.commentComposer__inner-->
        <div
            class="commentComposer__actions"
        >
            <div class="commentComposer__cancel">
                <button class="stripButton" @click="$emit('close')">
                    Cancel
                </button>
            </div>
            <div class="commentComposer__submit">
                <button
                    class="button -green"
                    @click="handleCommentEdit"
                >
                    Save
                </button>
            </div>
            <!--/.commentComposer__submit-->
        </div>
        <!--/.commentComposer__actions-->
    </div>
    <!--/.commentComposer-->
</template>
<script>
import { EditorContent, Editor } from 'tiptap';
import { mapActions, mapState } from 'vuex';

import AvatarImage from '../AvatarImage.vue';

export default {
    name: 'CommentComposer',
    components: {
        AvatarImage,
        EditorContent,
    },
    props: {
        parentId: {
            type: Number,
            default: null,
        },
        content: {
            type: String,
            default: '',
        },
        commentId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            editor: new Editor({
                content: this.content || '',
                autoFocus: true,
            }),
        };
    },
    computed: {
        ...mapState(['user']),
        ...mapState('comments', ['article']),
    },
    methods: {
        ...mapActions('comments', ['editComment', 'editChildComment']),
        handleCommentEdit() {
            axios.patch(`/api/comments/${this.commentId}`, {
                body: this.editor.getHTML(),
            }).then((response) => {
                if (this.parentId) {
                    this.editChildComment({
                        editedComment: response.data.data,
                        parentId: this.parentId,
                    });
                } else {
                    this.editComment(response.data.data);
                }
                this.$emit('close');
            });
        },
    },
};
</script>

<style lang="scss">
    .commentComposer__input p.is-editor-empty:first-child::before {
        content: attr(data-empty-text);
        float: left;
        padding-left: 0.4rem;
        color: hsl(0, 1%, 75%);
        pointer-events: none;
        height: 0;
        font-style: italic;
        font-size: 1.8rem;
    }

    .ProseMirror:focus {
        outline: none;
        border: none;
    }
</style>
